import styled from "styled-components";
import AntEmpty from "antd/es/empty";

const Empty = styled(AntEmpty)`
  .ant-empty-description {
    color: ${(p) => p.theme.colors.secondaryGrey};
  }
  .ant-empty-img-simple-ellipse,
  .ant-empty-img-simple-path {
    fill: ${(p) => p.theme.colors.emptyColor}!important;
  }
  .ant-empty-image svg {
    path,
    ellipse {
      fill: ${(p) => p.theme.colors.emptyColor} !important;
    }
  }
`;

export default Empty;
